export default "__VITE_ASSET__8d9fcf47__"